import React, { useState, useEffect } from 'react';

const TypingAnimation = ( {textArray = ["Hello", "World"], waitTime = 100, pauseTime = 2500, className} ) => {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(waitTime);

  useEffect(() => {
    // Define a 
    const handleType = () => {
      const currentText = textArray[loopNum];
      if (!isDeleting) {
        setText(currentText.substring(0, text.length + 1));
      } else {
        setText(currentText.substring(0, text.length - 1));
        setTypingSpeed(waitTime)
      }
      if (text === currentText && !isDeleting) {
        setIsDeleting(true);
        setTypingSpeed(pauseTime)
      } else if (text === '' && isDeleting) {
        setIsDeleting(false);
        setLoopNum(loopNum => loopNum === textArray.length - 1 ? 0 : loopNum + 1);
      }
    };
    const typingInterval = setInterval(() => handleType(), typingSpeed);
    return () => clearInterval(typingInterval);
  }, [text, isDeleting, loopNum, typingSpeed, textArray, waitTime]);

  return (
    <div className={`inline-block ${className}`}>
      <span className=''>{text}<span className='bg-dark dark:bg-light w-4 h-8 sm:h-10 md:h-12 inline-block ml-0.5 animate-blink'></span></span>
    </div>
  );
};

export default TypingAnimation;
